import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarItinerarios from '../../actions/itinerario/buscarItinerarios';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getOperadorEmpresa,
    getGestorOperacoes,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import selecionarRota from '../../actions/rota/selecionarRota';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import buscarUsuariosMotorista from '../../actions/usuario/buscarUsuariosMotorista';
import {showSuccessMsg} from '../../util/messagesUtil';
import Itinerarios from './Itinerarios';
import OperacoeItinerarioEmLote from './OperacoeItinerarioEmLote';
import buscarPrestadoresSimples from '../../actions/prestador/buscarPrestadoresSimples';
import PainelFiltragem from '../itinerario/PainelFiltrosItinerario';
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import { buscarUsuariosVendedores } from '../../actions/usuario/buscarUsuarios';


export class PainelGerenciarItinerarios extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            rotaSelecionada: null,
            motoristasSelecionados: [],
            trechosSelecionados: []
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinaPaginaAtual(1)
    }

    componentDidMount() {
        this.props.buscarTiposPreco();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
            this.props.buscarPrestadoresSimples(this.props.empresaSelecionada.id);
            this.props.buscarRotas(this.props.empresaSelecionada.id, null, null, null, true);
            this.props.buscarVeiculos(this.props.empresaSelecionada.id,null, null, null, false);
            this.props.buscarUsuariosVendedores(this.props.empresaSelecionada.id);
            if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
                this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id,null, null, null, false);
                this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
            }
            this.props.selecionarRota([]);
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
        }
    }


    buscarItinerarios() {
        this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    excluir() {
        this.props.excluirItinerarios(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Itinerário excluido com sucesso.');

                this.buscarItinerarios();
                this.props.selecionarItinerario(null);
            })
    }


    limparCampos() {
        this.props.changeFieldValue('formularioCadastroItinerario',
            'itinerarioId', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'veiculo', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'rota', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'assentosDisponiveis', '');
        this.props.selecionarItinerario(null);
        this.props.limparItinerarios()
    }


    exibirBotaoNovoItinerario() {
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getGestorOperacoes(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                    <div className="vx-gp-toolbar">
                        <button data-toggle="modal" data-target="#modalCadastrarItinerario"
                                className="vx-btn-primary">
                            <i className="material-icons" style={{ fontSize: '18px' }}>add</i>
                            Criar Itinerário
                        </button>
                        <button data-toggle="modal" data-target="#modalCadastrarItinerarioPorPeriodo"
                                className="vx-btn-primary">
                            <i className="material-icons" style={{ fontSize: '18px' }}>date_range</i>
                            Criar por Período
                        </button>
                        <OperacoeItinerarioEmLote habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                    </div>
                </Autorizacao>
            );
        }
        return null;
    }

    selecionarRota(rota) {
        this.props.selecionarRota(rota);
        this.props.buscarItinerarios(this.props.empresaSelecionada.id, rota.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
        this.props.buscarTrechos(this.props.empresaSelecionada.id, rota.value);
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: `${elemento.id}: ${elemento.descricao}`,
                                value: elemento.id,
                              cidadeOrigem: elemento.cidadeOrigem,
                              cidadeDestino: elemento.cidadeDestino,
                              prefixo: elemento.prefixo
                            }))}
                        onChange={value => this.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    exibirCamposBusca() {
        return (
            <div style={{ marginBottom: '16px' }}>
                <label style={{ fontWeight: 600, fontSize: '13px', marginBottom: '4px', display: 'block', color: '#555' }}>
                    Rota / Prestador
                </label>
                <Field name='rota' component={this.exibirComboRotas.bind(this)}/>
            </div>
        );
    }

    render() {
        const rotaSelecionada = this.props.rotaSelecionada && this.props.rotaSelecionada.value;
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao">
                    <Titulo texto="Gerenciar Itinerários" urlRetorno="/menu-itinerario"/>
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <CampoSelecionarEmpresa/>
                    </Autorizacao>
                    {this.exibirCamposBusca()}
                    {rotaSelecionada && <PainelFiltragem/>}
                    {this.exibirBotaoNovoItinerario()}
                    {rotaSelecionada && (
                        <div style={{ textAlign: 'center', margin: '12px 0 8px', fontWeight: 700, fontSize: '15px', color: '#333' }}>
                            {`${this.props.rotaSelecionada.label}`}
                        </div>
                    )}
                    <Itinerarios isEdicao={true} buscarItinerarios={this.buscarItinerarios.bind(this)} />
                </div>
            </Autorizacao>
        );
    }
}


export const mapStateToProps = state => (
    {
        itinerarios: state.itinerarios.itinerarios,
        veiculos: state.veiculos.veiculos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,
    });


export default connect(mapStateToProps,
    {
        buscarItinerarios,
        excluirItinerarios,
        buscarRotas,
        buscarVeiculos,
        determinaPaginaAtual,
        selecionarRota,
        limparItinerarios,
        buscarTiposPreco,
        selecionarItinerario,
        buscarUsuariosMotorista,
        buscarPrestadoresSimples,
        buscarTrechos,
        buscarUsuariosVendedores
    })(reduxForm({
    form: 'formularioCadastroItinerario'
})(PainelGerenciarItinerarios))